import { render, staticRenderFns } from "./commonPage.vue?vue&type=template&id=1d39ba4e"
import script from "./commonPage.vue?vue&type=script&lang=js"
export * from "./commonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d39ba4e')) {
      api.createRecord('1d39ba4e', component.options)
    } else {
      api.reload('1d39ba4e', component.options)
    }
    module.hot.accept("./commonPage.vue?vue&type=template&id=1d39ba4e", function () {
      api.rerender('1d39ba4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/entry/components/commonPage.vue"
export default component.exports